import { html } from '@inter-ikea-kompis/web-component';
import type { RenderResult } from '@inter-ikea-kompis/web-component';

import type ISummaryPageCustomTabButton from '../types/ISummaryPageCustomTabButton.js';

export default class SummaryPageCustomTabsUtility {
	/**
	 * @param customTabButtons ...
	 * @throws Error if customTabButtons has more than 5 items.
	 */
	public static getNumberOfCustomTabsToShow(
		customTabButtons: ISummaryPageCustomTabButton[] | null
	): number {
		const buttons = customTabButtons?.length ?? 0;

		if (buttons > 5) {
			console.error('Maximum five custom tabs are allowed');
			return 5;
		}

		return buttons;
	}

	public static getCustomTabSlots(numberOfCustomTabs: number): RenderResult[] {
		const slots: RenderResult[] = [];
		for (let n = 1; n <= numberOfCustomTabs; n++) {
			slots.push(html`<slot slot="custom-tab-${n}" name="custom-tab-${n}"></slot>`);
		}
		return slots;
	}
}
